module.exports = __webpack_public_path__ + "static/img/m_role.303e161.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/wxsjglm/m_role.png
// module id = 0/q/
// module chunks = 7